














































import Component from 'vue-class-component';
import { IDictionary } from '@/entities/dictionary.interface';
import { IFormControl } from '@/entities/form.interface';
import { EditPage } from '@/components/base/edit/edit-page';
import * as types from '@/store/types';
import { mapGetters } from 'vuex';
import blackListIpsApi from '@/api/black-list-ips.api';


@Component({

    computed: mapGetters({
        superAdminPermissions: types.AUTH_HAS_SUPERADMIN_PERMISSIONS,
        adminPermissions: types.AUTH_HAS_ADMIN_PERMISSIONS,
    })
})
export default class BlackListIpsAdd extends EditPage {
    public parentPath: string = '/app/settings/black-list-ip/';

    //  public companies: IListItem[] = [];
    public formState: IDictionary<IFormControl> = {
        ip: {
            key: 'ip',
            label: 'IP List',
            value: '',
            validators: 'required'
        }
    };

    protected superAdminPermissions: boolean;

    public async created() {
        await super.created();
    }

    public create(): Promise<void> {
        let ips = this.formState.ip.value.trim().split('\n');

        ips.forEach(async (ip) => {
            await blackListIpsApi.create({ip});
        });

        return Promise.resolve();
    }

    protected detail(id: number): Promise<any> {
        return Promise.resolve(undefined);
    }

    protected update(body: any): Promise<any> {
        return Promise.resolve(undefined);
    }


}
